export default __webpack_public_path__ + "static/media/listIconBlue.0e38718b.svg";